/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-use-before-define */
import { View } from 'react-native';
import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState, } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Zoom } from "swiper";
import { Autoplay } from 'swiper';
import { useStyle } from './style';
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/autoplay';
import "swiper/css/zoom";
const WSwiper = forwardRef((props, ref) => {
    const { kidtoken = '', scalable, customStyle, loop = true, autoPlay = true, duration = 0.5, initialIndex = 0, interval = 2.5, data = [], renderItem, scrollEnabled = true, indicatorSpace = false, indicatorPlacement = 'right', showIndicator = true, indicatorType = 'common', onIndexChanged = () => { }, customIndicator: CustomIndicator, } = props;
    const { vars, style } = useStyle({ kidtoken, scalable, customStyle });
    const total = useRef(0);
    const swiperRef = useRef(null);
    const [curIndex, setCurIndex] = useState(initialIndex);
    const swiperProps = {
        modules: [Autoplay, Zoom],
        zoom: true,
        initialSlide: initialIndex,
        autoplay: autoPlay
            ? {
                delay: interval * 1000,
                disableOnInteraction: false,
                stopOnLastSlide: true,
            }
            : autoPlay, // 自动播放和时间间隔
        pagination: false, // 是否展示指示器
        speed: duration * 1000, // 播放速度
        spaceBetween: 0, // 两个轮播项之前的间隙
        centeredSlides: true, // 当前选中幻灯片居中
        loop,
        autoHeight: true,
        allowTouchMove: scrollEnabled,
        onSlideChange: (swiper) => {
            setCurIndex(swiper.realIndex);
            if (curIndex !== swiper.realIndex) {
                onIndexChanged(swiper.realIndex);
            }
        },
        onSwiper: (swiper) => {
            initialSwiper(swiper);
        },
    };
    useEffect(() => {
        if (autoPlay && !swiperRef.current.autoplay.running) {
            swiperRef.current.autoplay.start();
        }
    }, [curIndex]);
    // 子元素集合
    const initialSwiper = (swiper) => {
        swiperRef.current = swiper;
        setCurIndex(swiper.realIndex);
        // 注册监听滚动事件
        swiperRef.current.on('touchStart', function (_swiper, event) {
            onScrollBeginDrag(_swiper, event);
        });
        swiperRef.current.on('touchEnd', function (_swiper, event) {
            onScrollEndDrag(_swiper, event);
        });
        swiperRef.current.on('slideChangeTransitionStart', function (_swiper) {
            onScrollBegin(_swiper);
        });
        swiperRef.current.on('slideChangeTransitionEnd', function (_swiper) {
            onScrollEnd(_swiper);
        });
    };
    // 滚动到下一页
    const next = () => {
        var _a;
        (_a = swiperRef.current) === null || _a === void 0 ? void 0 : _a.slideNext();
    };
    // 滚动到上一页
    const prev = () => {
        var _a;
        (_a = swiperRef.current) === null || _a === void 0 ? void 0 : _a.slidePrev();
    };
    // 滚动到第几个位置
    const scrollTo = (index) => {
        var _a;
        if (loop) {
            // eslint-disable-next-line no-param-reassign
            index = index + 1;
        }
        (_a = swiperRef.current) === null || _a === void 0 ? void 0 : _a.slideTo(index, 0);
    };
    /**
     * 外部通过ref访问
     */
    useImperativeHandle(ref, () => ({
        prev: () => {
            if (!loop && curIndex <= 0) {
                return;
            }
            prev();
        },
        next: () => {
            if (!loop && curIndex >= total.current - 1) {
                return;
            }
            next();
        },
        scrollTo: (index) => {
            if (index === curIndex)
                return;
            scrollTo(index);
        },
    }));
    /**
     * 滑动开始
     * @param  {object} swiper object
     */
    const onScrollBegin = (swiper) => {
        props.onScrollBegin && props.onScrollBegin(swiper);
    };
    /**
     * 滑动结束
     * @param  {object} swiper object
     */
    const onScrollEnd = (swiper) => {
        props.onScrollEnd && props.onScrollEnd(swiper);
    };
    /**
     * 拖拽开始
     * @param  {object} e native event
     */
    const onScrollBeginDrag = (swiper, event) => {
        props.onScrollBeginDrag && props.onScrollBeginDrag(event);
    };
    /**
     * 拖拽结束
     * @param  {object} e native event
     */
    const onScrollEndDrag = (swiper, event) => {
        props.onScrollEndDrag && props.onScrollEndDrag(event);
    };
    /**
     * render子节点
     */
    const renderChilds = () => {
        const childsArr = data.map((item, index) => {
            return (React.createElement(SwiperSlide, null,
                React.createElement(View, { style: [style.slideStyleWeb] },
                    React.createElement("div", { className: "swiper-zoom-container" }, renderItem({ item, index })))));
        });
        total.current = childsArr ? childsArr.length : 0;
        return childsArr;
    };
    return (React.createElement(View, { style: style.container },
        React.createElement(Swiper, Object.assign({}, swiperProps, { style: {
                width: vars.kibt_swiper_size_width,
                height: vars.kibt_swiper_size_height,
                borderRadius: vars.kibt_swiper_size_border_radius,
            } }), renderChilds()),
        showIndicator && data.length > 1 && (CustomIndicator ?
            React.createElement(CustomIndicator, { swiperProps: { curIndex, total: data.length } }) :
            React.createElement(View, { style: style.indicatorHorizontalWrapper }, data.map((item, index) => {
                const active = index === curIndex;
                return (React.createElement(View, { key: index, style: [style.indicatorItem, active ? style.indicatorActive : {}] }));
            })))));
});
export { WSwiper };
